import { useEffect, useState } from 'react';
import {
    OPEN_PRIVACY_CHOICES_EVENT,
    applyConsent,
    hasGlobalPrivacyControl,
    readStoredConsent,
    writeStoredConsent,
} from '../utils/cookieConsent.js';
import './styles/CookieConsentBanner.css';

export default function CookieConsentBanner() {
    const [visible, setVisible] = useState(false);
    const [managing, setManaging] = useState(false);
    const [analytics, setAnalytics] = useState(false);
    const [ads, setAds] = useState(false);
    const globalPrivacyControl = hasGlobalPrivacyControl();

    useEffect(() => {
        const stored = readStoredConsent();
        if (!stored) {
            setVisible(true);
            return;
        }

        setAnalytics(stored.analytics);
        setAds(stored.ads && !globalPrivacyControl);
        applyConsent(stored);
    }, [globalPrivacyControl]);

    useEffect(() => {
        const open = () => {
            const stored = readStoredConsent();
            setAnalytics(Boolean(stored?.analytics));
            setAds(Boolean(stored?.ads) && !hasGlobalPrivacyControl());
            setManaging(true);
            setVisible(true);
        };

        window.addEventListener(OPEN_PRIVACY_CHOICES_EVENT, open);
        return () => window.removeEventListener(OPEN_PRIVACY_CHOICES_EVENT, open);
    }, []);

    function save(choice) {
        const stored = writeStoredConsent({
            analytics: choice.analytics,
            ads: choice.ads && !hasGlobalPrivacyControl(),
        });
        applyConsent(stored);
        setVisible(false);
        setManaging(false);
    }

    if (!visible) {
        return null;
    }

    return (
        <div className="cookie-consent" role="dialog" aria-labelledby="cookie-consent-title">
            <div className="cookie-consent__card">
                <h2 id="cookie-consent-title">Your privacy choices</h2>
                <p>
                    We use optional analytics and advertising tools only after you allow them. Strictly necessary
                    storage, such as keeping you signed in, does not depend on this choice.
                </p>
                {globalPrivacyControl && (
                    <p className="cookie-consent__note">
                        Your browser is sending Global Privacy Control, so advertising and sharing stay off.
                    </p>
                )}
                {managing && (
                    <div className="cookie-consent__options">
                        <label>
                            <input
                                type="checkbox"
                                checked={analytics}
                                onChange={(event) => setAnalytics(event.target.checked)}
                            />
                            Analytics (Google Analytics)
                        </label>
                        <label>
                            <input
                                type="checkbox"
                                checked={ads}
                                disabled={globalPrivacyControl}
                                onChange={(event) => setAds(event.target.checked)}
                            />
                            Advertising and measurement tags
                        </label>
                    </div>
                )}
                <div className="cookie-consent__actions">
                    <button type="button" className="cookie-consent__button" onClick={() => save({ analytics: false, ads: false })}>
                        Reject non-essential
                    </button>
                    {managing ? (
                        <button type="button" className="cookie-consent__button cookie-consent__button--primary" onClick={() => save({ analytics, ads })}>
                            Save choices
                        </button>
                    ) : (
                        <button type="button" className="cookie-consent__button" onClick={() => setManaging(true)}>
                            Manage
                        </button>
                    )}
                    <button type="button" className="cookie-consent__button cookie-consent__button--primary" onClick={() => save({ analytics: true, ads: true })}>
                        Accept all
                    </button>
                </div>
            </div>
        </div>
    );
}
